var _excluded = ["data"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import axios from 'axios';
import { parseAxiosCancelToken } from '../utils/axios';
export var AbstractEntityService = /*#__PURE__*/function () {
  function AbstractEntityService() {
    _classCallCheck(this, AbstractEntityService);
  }

  _createClass(AbstractEntityService, [{
    key: "execFetchMany",
    value: function () {
      var _execFetchMany = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url) {
        var opts,
            res,
            builtUrl,
            req,
            _req$data,
            data,
            meta,
            _args = arguments;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                opts = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                res = AbstractEntityService.buildResponse();
                _context.prev = 2;
                builtUrl = AbstractEntityService.buildUrl(url, opts);
                _context.t0 = axios;
                _context.t1 = builtUrl;
                _context.t2 = _objectSpread;
                _context.t3 = {};
                _context.next = 10;
                return AbstractEntityService.buildRequestConfig(opts);

              case 10:
                _context.t4 = _context.sent;
                _context.t5 = (0, _context.t2)(_context.t3, _context.t4);
                _context.next = 14;
                return _context.t0.get.call(_context.t0, _context.t1, _context.t5);

              case 14:
                req = _context.sent;
                _req$data = req.data, data = _req$data.data, meta = _objectWithoutProperties(_req$data, _excluded);
                res.ok = true;
                res.data = data;
                res.meta = meta;
                _context.next = 25;
                break;

              case 21:
                _context.prev = 21;
                _context.t6 = _context["catch"](2);

                if (axios.isCancel(_context.t6)) {
                  res.cancelled = true;
                }

                res.error = _context.t6;

              case 25:
                return _context.abrupt("return", res);

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 21]]);
      }));

      function execFetchMany(_x) {
        return _execFetchMany.apply(this, arguments);
      }

      return execFetchMany;
    }()
  }, {
    key: "execFetchOne",
    value: function () {
      var _execFetchOne = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url) {
        var opts,
            _args2 = arguments;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                opts = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
                return _context2.abrupt("return", this.execGet(url, opts));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function execFetchOne(_x2) {
        return _execFetchOne.apply(this, arguments);
      }

      return execFetchOne;
    }()
  }, {
    key: "execGet",
    value: function () {
      var _execGet = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(url) {
        var opts,
            res,
            builtUrl,
            req,
            _args3 = arguments;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                opts = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
                res = AbstractEntityService.buildResponse();
                _context3.prev = 2;
                builtUrl = AbstractEntityService.buildUrl(url, opts);
                _context3.t0 = axios;
                _context3.t1 = builtUrl;
                _context3.t2 = _objectSpread;
                _context3.t3 = {};
                _context3.next = 10;
                return AbstractEntityService.buildRequestConfig(opts);

              case 10:
                _context3.t4 = _context3.sent;
                _context3.t5 = (0, _context3.t2)(_context3.t3, _context3.t4);
                _context3.next = 14;
                return _context3.t0.get.call(_context3.t0, _context3.t1, _context3.t5);

              case 14:
                req = _context3.sent;
                res.ok = true;
                res.data = req.data.data;
                _context3.next = 23;
                break;

              case 19:
                _context3.prev = 19;
                _context3.t6 = _context3["catch"](2);

                if (axios.isCancel(_context3.t6)) {
                  res.cancelled = true;
                }

                res.error = _context3.t6;

              case 23:
                return _context3.abrupt("return", res);

              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[2, 19]]);
      }));

      function execGet(_x3) {
        return _execGet.apply(this, arguments);
      }

      return execGet;
    }()
  }, {
    key: "execPost",
    value: function () {
      var _execPost = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(url, postData) {
        var opts,
            res,
            builtUrl,
            req,
            _args4 = arguments;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                opts = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
                res = AbstractEntityService.buildResponse();
                _context4.prev = 2;
                builtUrl = AbstractEntityService.buildUrl(url, opts);
                _context4.t0 = axios;
                _context4.t1 = builtUrl;
                _context4.t2 = postData;
                _context4.t3 = _objectSpread;
                _context4.t4 = {};
                _context4.next = 11;
                return AbstractEntityService.buildRequestConfig(opts);

              case 11:
                _context4.t5 = _context4.sent;
                _context4.t6 = (0, _context4.t3)(_context4.t4, _context4.t5);
                _context4.next = 15;
                return _context4.t0.post.call(_context4.t0, _context4.t1, _context4.t2, _context4.t6);

              case 15:
                req = _context4.sent;
                res.ok = true;
                res.data = req.data.data;
                _context4.next = 24;
                break;

              case 20:
                _context4.prev = 20;
                _context4.t7 = _context4["catch"](2);

                if (axios.isCancel(_context4.t7)) {
                  res.cancelled = true;
                }

                res.error = _context4.t7;

              case 24:
                return _context4.abrupt("return", res);

              case 25:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[2, 20]]);
      }));

      function execPost(_x4, _x5) {
        return _execPost.apply(this, arguments);
      }

      return execPost;
    }()
  }, {
    key: "execCreate",
    value: function () {
      var _execCreate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(url, createDto) {
        var opts,
            _args5 = arguments;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                opts = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {};
                return _context5.abrupt("return", this.execPost(url, createDto, opts));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function execCreate(_x6, _x7) {
        return _execCreate.apply(this, arguments);
      }

      return execCreate;
    }()
  }, {
    key: "execPatch",
    value: function () {
      var _execPatch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(url, updateDto) {
        var opts,
            res,
            builtUrl,
            req,
            _args6 = arguments;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                opts = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                res = AbstractEntityService.buildResponse();
                _context6.prev = 2;
                builtUrl = AbstractEntityService.buildUrl(url, opts);
                _context6.t0 = axios;
                _context6.t1 = builtUrl;
                _context6.t2 = updateDto;
                _context6.t3 = _objectSpread;
                _context6.t4 = {};
                _context6.next = 11;
                return AbstractEntityService.buildRequestConfig(opts);

              case 11:
                _context6.t5 = _context6.sent;
                _context6.t6 = (0, _context6.t3)(_context6.t4, _context6.t5);
                _context6.next = 15;
                return _context6.t0.patch.call(_context6.t0, _context6.t1, _context6.t2, _context6.t6);

              case 15:
                req = _context6.sent;
                res.ok = true;
                res.data = req.data.data;
                _context6.next = 24;
                break;

              case 20:
                _context6.prev = 20;
                _context6.t7 = _context6["catch"](2);

                if (axios.isCancel(_context6.t7)) {
                  res.cancelled = true;
                }

                res.error = _context6.t7;

              case 24:
                return _context6.abrupt("return", res);

              case 25:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[2, 20]]);
      }));

      function execPatch(_x8, _x9) {
        return _execPatch.apply(this, arguments);
      }

      return execPatch;
    }()
  }, {
    key: "execDelete",
    value: function () {
      var _execDelete = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(url) {
        var opts,
            res,
            builtUrl,
            _args7 = arguments;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                opts = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
                res = AbstractEntityService.buildResponse();
                _context7.prev = 2;
                builtUrl = AbstractEntityService.buildUrl(url, opts);
                _context7.t0 = axios;
                _context7.t1 = builtUrl;
                _context7.t2 = _objectSpread;
                _context7.t3 = {};
                _context7.next = 10;
                return AbstractEntityService.buildRequestConfig(opts);

              case 10:
                _context7.t4 = _context7.sent;
                _context7.t5 = (0, _context7.t2)(_context7.t3, _context7.t4);
                _context7.next = 14;
                return _context7.t0["delete"].call(_context7.t0, _context7.t1, _context7.t5);

              case 14:
                res.ok = true;
                res.data = 'success';
                _context7.next = 22;
                break;

              case 18:
                _context7.prev = 18;
                _context7.t6 = _context7["catch"](2);

                if (axios.isCancel(_context7.t6)) {
                  res.cancelled = true;
                }

                res.error = _context7.t6;

              case 22:
                return _context7.abrupt("return", res);

              case 23:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[2, 18]]);
      }));

      function execDelete(_x10) {
        return _execDelete.apply(this, arguments);
      }

      return execDelete;
    }()
  }], [{
    key: "buildUrl",
    value:
    /**
     * Adds additional query params found in opts to the provided url.
     */
    function buildUrl(url) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var u = new URL(url);

      if (opts.query) {
        for (var key in opts.query) {
          if (opts.query.hasOwnProperty(key)) {
            var value = opts.query[key];

            if (value !== undefined) {
              u.searchParams.append(key, opts.query[key]);
            }
          }
        }
      }

      return u.toString();
    }
    /**
     * Builds standard axios request config shared between all api calls
     */

  }, {
    key: "buildRequestConfig",
    value: function () {
      var _buildRequestConfig = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var opts,
            _args8 = arguments;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                opts = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
                _context8.next = 3;
                return parseAxiosCancelToken(opts);

              case 3:
                _context8.t0 = _context8.sent;
                return _context8.abrupt("return", {
                  cancelToken: _context8.t0
                });

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function buildRequestConfig() {
        return _buildRequestConfig.apply(this, arguments);
      }

      return buildRequestConfig;
    }()
    /**
     * Builds standard response package shared between all api responses
     */

  }, {
    key: "buildResponse",
    value: function buildResponse() {
      return {
        ok: false,
        data: undefined,
        meta: {},
        cancelled: false,
        error: undefined
      };
    }
  }]);

  return AbstractEntityService;
}();